<template>
  <div class="w-full h-full px-10px py-20px text-[14px] text-[#fff]">
    <categoryTitle title="基础信息"></categoryTitle>
    <div class="p-10px mt-10px ">
      <div class="flex justify-between mb-20px w-full overflow-hidden">
        <div class="text-ellipsis w-[calc(50%-5px)] whitespace-nowrap overflow-hidden">
          任务编号：{{ taskInfo.code }}
        </div>
        <div class="text-ellipsis w-[calc(50%-5px)] whitespace-nowrap overflow-hidden">
          任名称：{{ taskInfo.name }}
        </div>
      </div>
      <div class="card-process mb-20px w-full p-10px">
        <el-row class="w-full">
          <el-col :span="12" class="text-center">
            <div class="mb-10px">计划开始时间</div>
            <div class="time">{{ taskInfo.planStartDt }}</div>
          </el-col>
          <el-col :span="12" class="text-center">
            <div class="mb-10px">计划结束时间</div>
            <div class="time">{{ taskInfo.planCompleteDt }}</div>
          </el-col>
        </el-row>
      </div>
      <div class="card-process w-full p-10px mb-20px">
        <el-row class="w-full">
          <el-col :span="12" class="text-center">
            <div class="mb-10px">实际开始时间</div>
            <div class="time">{{ taskInfo.startDt }}</div>
          </el-col>
          <el-col :span="12" class="text-center">
            <div class="mb-10px">实际结束时间</div>
            <div class="time">{{ taskInfo.completeDt }}</div>
          </el-col>
        </el-row>
      </div>

      <el-row type="flex" justify="space-around">
        <el-col :span="8" class="flex flex-col justify-center items-center">
          <img class="w-67px h-67px" src="../../assets/images/process/plan.png" alt="" />

          <div class="text-center day-plan my-5px">
            {{ taskInfo.planSchedule||0 }}
          </div>

          <div class="text-center">计划工期</div>
        </el-col>
        <el-col :span="8" class="flex flex-col justify-center items-center">
          <img class="w-67px h-67px" src="../../assets/images/process/actual.png" alt="" />
          <div class="text-center day my-5px">{{ taskInfo.actualSchedule ||0}}</div>

          <div class="text-center">实际工期</div>
        </el-col>
        <el-col :span="8" class="flex">
          <div class="flex mt-20px mb-10px">
            <img class="mr-10px" src="../../assets/images/process/devide.png" alt="" />
            <div class="flex flex-col justify-between">
              <div>负责人</div>

              <div class="header">
                {{ taskInfo.head }}
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { PlanTaskApi } from '@wiz-api/construction-schedule-management'
import dayjs from 'dayjs'
import categoryTitle from '@/components/cockpit/CategoryTitle'

const planTaskApi = new PlanTaskApi()

export default {
  props: {
    transferProps: {
      type: Object,
      defalut: () => {},
    },
  },
  components: { categoryTitle },
  data() {
    return {

      taskInfo: {},
    }
  },
  methods: {
    async getInfo() {
      const [err, res] = await planTaskApi.get(this.transferProps.taskId)
      res.planStartDt ? (res.planStartDt = dayjs(res.planStartDt).format('YYYY-MM-DD')) : null
      res.planCompleteDt
        ? (res.planCompleteDt = dayjs(res.planCompleteDt).format('YYYY-MM-DD'))
        : null
      res.startDt ? (res.startDt = dayjs(res.startDt).format('YYYY-MM-DD')) : null
      res.completeDt ? (res.completeDt = dayjs(res.completeDt).format('YYYY-MM-DD')) : null
      this.taskInfo = res
    },
  },
  watch: {
    transferProps: {
      handler() {
        this.getInfo()
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},
}
</script>

<style lang="scss" scoped>
.el-descriptions {
  color: #fff;

  ::v-deep.el-descriptions__body {
    background-color: transparent;
    padding-left: 10px;
    color: #fff;
  }
}
.card-process {
  background-image: url('../../assets/images/process/info-bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .time {
    color: #42e3f1;
    font-weight: bold;
  }
}
.day-plan {
  font-size: 20px;
  color: transparent;
  text-align: center;
  -webkit-background-clip: text;
  background-clip: text;
  background: linear-gradient(90deg, #fffef7 18%, #ebe07b 58%, #8f8a19 100%);
  background-size: 100% 100%;
  background-clip: text;
}
.day {
  text-align: center;
  font-size: 20px;
  background: linear-gradient(90deg, #f7feff 18%, #7bcdeb 58%, #196f8f 100%);
  background-size: 100% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}
.header {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  max-height: calc(1.2em * 3);
  line-height: 1.2;
  font-size: 16px;
}
</style>
